import {
  UseMutationResult,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
import { type ShowsSeries, createSeries, SERIES_QUERY_KEY } from "./api";

interface CreateSeriesParams {
  name: string;
  venuePageId: string;
  venuePageShowIds: string[];
}

/**
 * Hook to create a new series and assign shows to it
 */
export function useCreateSeries(): UseMutationResult<
  ShowsSeries,
  Error,
  CreateSeriesParams
> {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ name, venuePageId, venuePageShowIds }: CreateSeriesParams) =>
      createSeries({
        name,
        venue_page_id: venuePageId,
        venue_page_show_ids: venuePageShowIds,
      }),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: [SERIES_QUERY_KEY, variables.venuePageId],
      });
    },
  });
}
